import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { withRouter } from 'react-router';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import queryString from 'query-string';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { logPageView, initGA } from 'utils/analytics';
import Banner from 'components/Banner';
import Details from 'components/Details';
import TextField from 'components/TextField';
import CustomButton from 'components/CustomButton';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { ViewAthlete } from './../../common/routes/routeNames';

import { forgot, setPassword } from './ForgotPassword.actions';
import { forgotSelector } from './ForgotPassword.redux';
import styles from './ForgotPassword.scss';

// to import local scss fle

class ForgotPassword extends Component {


  static propTypes = {
    success: PropTypes.bool.isRequired,
    forgot: PropTypes.func.isRequired,
    setPassword: PropTypes.func.isRequired,
    location: PropTypes.shape,
    isLoading: PropTypes.bool.isRequired,
    resetPasswordsuccess: PropTypes.bool,
    history: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    success: false,
    location: {},
    resetPasswordsuccess: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      setPassword: false,
      password: '',
      usernameForReset: '',
      newPassword: '',
      userName: '',
      userNameErrorMessage: '',
      newPasswordErrorMessage: '',
      confirmPasswordErrorMessage: '',
      passwordDidNotMatchErrorMessage: '',
      confirmPassword: '',
      query: {},
    };
    this.emailHandler = this.emailHandler.bind(this);
    this.submit = this.submit.bind(this);
    this.passwordHandler = this.passwordHandler.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.handleNewPassword = this.handleNewPassword.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
  }

  componentWillMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    if (query && Object.prototype.hasOwnProperty.call(query, 'code')) {
      this.setState({ query });
    }
  }
  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.resetPasswordsuccess !== this.props.resetPasswordsuccess) {
      this.props.history.push(ViewAthlete);
    }
  }

  setPassword = () => {
    const updated = {};
    // validations for new password
    let validUserName = false;
    if (this.state.usernameForReset !== '') {
      validUserName = true;
    } else {
      updated.userNameErrorMessage = 'Enter a valid user name.';
    }
    let validNewPassword = false;
    if (this.state.newPassword !== '' && this.state.newPassword.length >= 6) {
      validNewPassword = true;
    } else if (this.state.newPassword.length <= 6) {
      updated.newPasswordErrorMessage = 'Length of password should be more than 6.';
    } else {
      updated.newPasswordErrorMessage = 'New Password can not be blank.';
    }

    let validConfirmPassword = false;
    if (this.state.confirmPassword !== '') {
      validConfirmPassword = true;
    } else {
      updated.confirmPasswordErrorMessage = 'Confirm Password can not be blank.';
    }

     // validation for if password matches
    if (validNewPassword && validConfirmPassword && validUserName &&
        (this.state.newPassword === this.state.confirmPassword)) {
      this.props.setPassword(this.state.usernameForReset,
          this.state.query.code, this.state.newPassword);
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      updated.confirmPasswordErrorMessage = 'Confirm password did not match.';
    }

    this.setState(updated);
  };

  emailHandler = (username) => {
    this.setState({ username });
  };
  passwordHandler = (password) => {
    this.setState({ password });
  };
  submit = () => {
    this.props.forgot(this.state.username);
  };

  handleNewPassword(name, value) {
    this.setState({ ...this.state, [name]: value });
  }
  removeErrorMessage(name) {
    this.setState({ ...this.state, [name]: '' });
  }
  identifyEnter = (e) => {
    const { username } = this.state;
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter keycode
      if (username !== '') {
        this.props.forgot(username);
      } else if (username === '' && this.props.location.search === '') {
        this.setState({ userNameErrorMessage: 'Enter valid username' });
      } else {
        this.setPassword();
      }
    }
  }
  render() {
    let generateNewPassword = false;
    if (this.props.location.search !== '') {
      generateNewPassword = true;
    }
    const renderIfNotSetPassword = renderIf(!this.state.setPassword &&
                                   !this.props.success && !generateNewPassword);
    const renderLoading = renderIf(this.props.isLoading);
    const renderIfForgotSuccess = renderIf(this.props.success && !generateNewPassword);
    const renderIfNotSuccess = renderIf(!this.props.success && !generateNewPassword);
    const renderUpdatePassword = renderIf(generateNewPassword);

    const joinUsData = {
      bannerHeader: 'GET THE MORE OF YOU',
      bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
      detailsHeader: 'Forgot your password?',
      detailsDesc: 'Enter your email address below and we will get you back on track.',
      otherPages: true,
      page: 'logon',
    };

    const forgotData = {
      bannerHeader: 'GET THE MORE OF YOU',
      bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
      detailsHeader: '',
      detailsDesc: '',
      otherPages: true,
      page: 'register',
    };

    const createnewPassword = {
      bannerHeader: 'GET THE MORE OF YOU',
      bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
      detailsHeader: 'Create new password!',
      detailsDesc: '',
      otherPages: true,
      page: 'register',
    };
    return (
      <div className={cn('row', styles.container)}>

        <div className={cn('row', styles.joinUsContainer)}>
          <div className={cn('col s6', styles.joinUsBanner)}>
            <Banner data={joinUsData} />
          </div>
          {renderIfForgotSuccess(
            <div className={cn('col s12 m6', styles.joinUsDetails)}>
              <Details data={forgotData} {...this.props}>
                <span>
                  <span className={styles.successFull}>
                    Reset password link sent to your email.
                  </span>
                </span>
              </Details>

            </div>,
            )}
          {renderIfNotSuccess(<div className={cn('col s12 m6', styles.joinUsDetails)}>
            <Details data={joinUsData} {...this.props}>
              {renderIfNotSetPassword(
                <div>
                  <TextField
                    label="ENTER YOUR USERNAME"
                    errorMessage={this.state.userNameErrorMessage}
                    onChange={this.emailHandler}
                    onKeyPress={this.identifyEnter}
                  />
                  <CustomButton onClick={this.submit} />
                </div>,
                  )}
            </Details>
          </div>)}
          {renderUpdatePassword(
            <div className={cn('col s12 m6', styles.joinUsDetails)}>
              <Details data={createnewPassword} {...this.props}>
                <div>
                  <TextField
                    label="ENTER USERNAME"
                    errorMessage={this.state.userNameErrorMessage}
                    onKeyPress={this.identifyEnter}
                    onChange={val => this.handleNewPassword('usernameForReset', val)}
                    onFocus={() => this.removeErrorMessage('userNameErrorMessage')}
                  />
                  <TextField
                    label="ENTER NEW PASSWORD"
                    usedFor="forgotPassword"
                    onKeyPress={this.identifyEnter}
                    onChange={val => this.handleNewPassword('newPassword', val)}
                    errorMessage={this.state.newPasswordErrorMessage}
                    onFocus={() => this.removeErrorMessage('newPasswordErrorMessage')}
                  />
                  <TextField
                    label="CONFIRM PASSWORD AGAIN"
                    usedFor="forgotPassword"
                    onKeyPress={this.identifyEnter}
                    errorMessage={this.state.confirmPasswordErrorMessage}
                    onChange={val => this.handleNewPassword('confirmPassword', val)}
                    onFocus={() => this.removeErrorMessage('confirmPasswordErrorMessage')}
                  />
                  <CustomButton onClick={this.setPassword} label="save" />
                </div>
              </Details>
            </div>,
            )}

        </div>
        {renderLoading(
          <FullScreenLoader />,
          )}
      </div>
    );
  }
}


export default connect(forgotSelector, {
  forgot,
  setPassword,
})(withRouter(ForgotPassword));



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPassword.js